import ApolloClientConsumer from './ApolloClientConsumer';

export default ApolloClientConsumer;
